export function AmenityChips({
  amenities,
  pending,
  setPending,
  onAdd,
  onRemove,
}: {
  amenities: string[];
  pending: string;
  setPending: (v: string) => void;
  onAdd: () => void;
  onRemove: (a: string) => void;
}) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
      {amenities.map((a) => (
        <span key={a} className="nb-pill" style={{ height: 22, fontSize: 11 }}>
          {a}
          <button
            type="button"
            onClick={() => onRemove(a)}
            aria-label={`Remove ${a}`}
            style={{
              border: 0,
              background: 'transparent',
              color: 'var(--nb-faint)',
              cursor: 'pointer',
              marginLeft: 4,
            }}
          >
            ×
          </button>
        </span>
      ))}
      <input
        value={pending}
        onChange={(e) => setPending(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onAdd();
          }
        }}
        placeholder="Add amenity + Enter"
        style={{
          height: 22,
          fontSize: 11,
          padding: '0 8px',
          borderRadius: 999,
          border: '1px solid var(--nb-border-2)',
          background: 'var(--nb-bg)',
          color: 'var(--nb-ink)',
          outline: 'none',
        }}
      />
    </div>
  );
}
